module.exports = __webpack_public_path__ + "static/img/news6.e5ab6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news6.jpg
// module id = qFhU
// module chunks = 1